import { memo } from 'react';
import { FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Buttons/Button';

const ErrorView = ({ resetErrorBoundary }: FallbackProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center bg-cover bg-[top_center] bg-no-repeat px-[15px] text-center">
      <div className="text-ep_text flex max-w-[340px] flex-col gap-2 font-bold">
        <h3 className="text-2xl">{t('errorView.title')}</h3>
        <p className="text-[15px]">{t('errorView.description')}</p>

        <Button onClick={resetErrorBoundary} mode="button-primary">
          {t('general.retry')}
        </Button>
      </div>
    </div>
  );
};

export default memo(ErrorView);
